import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/rootReducer';
// import HSButton from '../../../common/Button';
import LinkButton from '../../../common/LinkButton';

type Props = {
    setIsTableOpen: () => void;
    userStatus: string;
};

const ReferralView: React.FC<Props> = ({ setIsTableOpen, userStatus }) => {
    const referralsData = useSelector((state: RootState) => state.referral.referrals);

    const data = [
        { value: (referralsData && referralsData.referredCount) || 0, subText: 'Referred' },
        { value: (referralsData && referralsData.successfulCount) || 0, subText: 'Successful Referrals' },
        {
            value: (referralsData && referralsData.totalFeePaid && referralsData.totalFeePaid.amountUpto2dp) || 0,
            subText: 'Referral Fee Disbursed',
            currency: referralsData && referralsData.totalFeePaid && referralsData.totalFeePaid.currency,
        },
    ];

    return (
        <div className="w-full mx-4">
            <div className="bg-center bg-cover w-full py-4 pb-12 md:py-12 md:px-20">
                <p className="not-italic text-[30px] md:text-[40px] font-[WorkSans-Semibold] text-[#13223E] py-2 uppercase">Your Referrals</p>

                {userStatus === 'Approved' && (
                    <>
                        {/* <p className="not-italic font-bold WorkSans text-[40px] text-[#20222B] py-2">
                            One place for all referral related information
                        </p> */}

                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 py-8">
                            {data.map((item, i) => (
                                <div key={`fourth_block${i}`} className="flex items-center py-2 md:py-0">
                                    <div className="w-full">
                                        <p className="font-[WorkSans-Semibold] text-[#152C52] text-4xl md:text-[90px]">
                                            {item.currency || ''} {item.value}
                                        </p>
                                        <div className="border-b w-4/5 border-[#000000] border-solid my-2 md:my-6" />
                                        <p className="font-[WorkSans] not-italic font-normal text-[#000000] text-lg md:text-[22px]">
                                            {item.subText}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                )}
                <div className="pt-2">
                    <LinkButton title="VIEW DETAILS" onClick={setIsTableOpen} isArrow  size="sm" />
                    {/* <HSButton transparent={true} isArrow={true} onClick={setIsTableOpen} title="View Details" /> */}
                </div>
            </div>
        </div>
    );
};

export default ReferralView;
